const employeeInitialState = {
  firm: [],
  selectedFirm: null,
  currentTab: 0,
  staffPermissionList: [],
};

const EmployeeReducer = (state = employeeInitialState, action) => {
  switch (action.type) {
    case "SET_FIRMS": {
      return { ...state, firm: action.data };
    }

    case "SELECTED_FIRM": {
      // Find the tab index for the selected company
      let tabIndex = state.currentTab;
      if (action.data) {
        tabIndex = state?.firm.findIndex(
          (company) => company.firm_id === action.data.firm_id,
        );
      }
      return {
        ...state,
        selectedFirm: action.data || null,
        currentTab: tabIndex >= 0 ? tabIndex : 0,
      };
    }
    case "PERMISSION_LIST": {
      return { ...state, staffPermissionList: action.data };
    }
    default:
      return state;
  }
};
export default EmployeeReducer;